<template>
  <v-layout column>
    <v-flex xs12 md12 >
      <v-toolbar color="white" flat v-if="!searchlistbot">
        <v-btn icon light @click="backToFriendList()">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 CSChatThai">จัดการข้อมูลบอท</v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-flex xs12 md12 >
      <v-card class="CSChatThai" style="margin: 4vw;" >
        <v-layout row wrap>
          <v-flex xs8 md8>
            <v-flex xs12 md12>
              <v-img
                class="white--text"
                aspect-ratio="1.5"
                :src="profilepicture"
                v-if="profilepicture != ''"
                @click="gotoinfo()"
              >
              </v-img>
              <v-img
                class="white--text"
                aspect-ratio="1.5"
                src="../../static/img/robot/robot1.png"
                v-else
                @click="gotoinfo()"
              >
              </v-img>
            </v-flex>
            <v-flex xs12 md12>
              <v-card-title primary-title>
                <div class="CSChatThai">
                  <h3 class="headline mb-0 CSChatThai">ข้อมูลบอท</h3>
                  <div>แสดงรายละเอียดของบอท, QR code, ภาพประจำตัวบอท และอื่น ๆ</div>
                </div>
              </v-card-title>
            </v-flex>
          </v-flex>
          <v-layout align-center justify-center row wrap>
            <v-btn flat icon @click="gotoinfo()">
              <v-icon style="font-size: 35px !important; color: #BEC8D2;">arrow_forward_ios</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12 md12>
      <v-card class="CSChatThai" style="margin: 4vw;">
        <v-layout row wrap>
          <v-flex xs8 md8>
            <v-flex xs12 md12>
              <v-img
                src='../../static/image/replymsg1.png'
                aspect-ratio="1.5"
                @click="gotomsgreply()"
              ></v-img>
            </v-flex>
            <v-flex xs12 md12>
              <v-card-title primary-title>
                <div class="CSChatThai">
                  <h3 class="headline mb-0 CSChatThai">ข้อความตอบกลับ อัตโนมัติ</h3>
                  <div>แสดงรายละเอียด เพิ่ม และ แก้ไข ข้อความตอบกลับ อัตโนมัติ</div>
                </div>
              </v-card-title>
            </v-flex>
          </v-flex>
          <v-layout align-center justify-center row wrap>
            <v-btn flat icon @click="gotomsgreply()">
              <v-icon style="font-size: 35px !important; color: #BEC8D2;">arrow_forward_ios</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        profilepicture: '',
        search: '',
        searchlistbot: false,
        name: '',
        email: '',
        token: '',
        phone: '',
        status: '',
        webbackend: '',
        filename: '',
        development: '',
        tokenservice: '',
        tokenuserQR: '',
        nameedit: '',
        statusedit: '',
        listbot: [],
        botid: '',
        windowWidth: ''
      }
    },
    created () {
      this.webbackend = process.env.API
      this.development = '-'
      this.botid = this.$route.params.id
      this.token = localStorage.getItem('tokenuser')
      this.$http.post(process.env.APImanage + '/searchuser2', {tokenuser: this.token, type: 'bot', key: this.botid}).then((response) => {
        if (response.body['status'] === 'success') {
          this.profilepicture = response.body.listuser[0].user.profilepicture
          this.name = response.body.listuser[0].user.name
        }
      }, (response) => {})
    },
    methods: {
      gotoinfo () {
        this.$router.push('/mobile/dev_editbot/' + this.botid)
      },
      gotomsgreply () {
        this.$router.push('/mobile/dev_msgreply/' + this.botid)
      },
      backToFriendList () {
        this.$emit('data', true)
        this.$router.push('/mobile/dev_listbot')
        this.$store.dispatch('tokenRoom', 'noneselect')
        this.$store.dispatch('changeRightTool', 'Friend')
        this.$cookies.set('tokenRoom', 'noneselect')
        localStorage.setItem('room', 'noneselect')
        this.$store.dispatch('changeGroup', 'noneselect')
      },
      findWithAttr (array, attr, value) {
        for (var i = 0; i < array.length; i += 1) {
          if (array[i][attr] === value) {
            return i
          }
        }
        return -1
      },
      gotoLink (link) {
        if (link === 'logout') {
          this.logout()
        } else {
          // console.log(link)
          this.$router.push(link)
        }
      }
    },
    computed: {
      FilterBotList () {
        if (this.search !== '' && this.search !== null) {
          return this.listbot.filter(post => {
            // console.log(this.search)
            return post.nickname.toLowerCase().includes(this.search.toLowerCase())
          })
        } else {
          return this.listbot
        }
      },
      ...mapState({
        myprofile: 'myprofile',
        botinfo: 'botinfo'
      })
    },
    mounted () {
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowWidth = window.innerWidth
        })
      })
    },
    watch: {
      windowWidth () {
        if (this.windowWidth > 960) {
          this.$router.push('/develop/homepage')
        }
      },
      myprofile () {
        // console.log('myProfile')
        this.filename = localStorage.getItem('profilepicture')
      },
      botinfo () {
        // this.profilepicture = this.botinfo.profilepicture
        // this.name = this.botinfo.nickname
        this.botid = this.$route.params.id
        this.token = localStorage.getItem('tokenuser')
        this.$http.post(process.env.APImanage + '/searchuser2', {tokenuser: this.token, type: 'bot', key: this.botid}).then((response) => {
          // console.log(response.body)
          if (response.body['status'] === 'success') {
            this.profilepicture = response.body.listuser[0].user.profilepicture
            this.name = response.body.listuser[0].user.name
          }
        }, (response) => {})
      }
    }
  }
</script>
<style type="text/css" scoped>
  .CSChatThai {
   font-family: 'CS ChatThaiUI' !important;
   word-wrap: break-word;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile/ManageBotMo.vue